import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KLandingHeader";
var classes = {
    root: "".concat(PREFIX, "-root"),
    logoContainer: "".concat(PREFIX, "-logoContainer"),
    logo: "".concat(PREFIX, "-logo"),
    title: "".concat(PREFIX, "-title"),
    kLanguageSwitcherContainer: "".concat(PREFIX, "-kLanguageSwitcherContainer"),
    kLanguageSwitcher: "".concat(PREFIX, "-kLanguageSwitcher")
};
var StyledKLandingHeader = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "logoCentered" &&
            prop !== "logoMaxHeight" &&
            prop !== "logoMarginTop" &&
            prop !== "imageComponent";
    }
})(function (_a) {
    var _b;
    var theme = _a.theme, logoCentered = _a.logoCentered, logoMaxHeight = _a.logoMaxHeight, logoMarginTop = _a.logoMarginTop, imageComponent = _a.imageComponent;
    return (_b = {},
        _b["&.".concat(classes.root)] = __assign(__assign({ display: "grid", gridColumnGap: !logoMarginTop ? theme.spacing(2) : 0, gridTemplateAreas: "\"logo logo language\" \"logoDown logoDown logoDown\"", gridTemplateColumns: "2fr 1fr !important" }, (logoCentered && {
            gridTemplateAreas: "\". logo language\" \"logoDown logoDown logoDown\"",
            gridTemplateColumns: " 1fr 1fr 1fr"
        })), { justifyItems: !logoCentered ? "flex-start !important" : "center" }),
        _b["& .".concat(classes.logoContainer)] = {
            gridArea: logoMarginTop ? "logoDown" : "logo",
            display: "flex",
            alignItems: "flex-end",
            margin: 0,
            position: "relative",
            minHeight: "100%",
            height: imageComponent && imageComponent.active ? theme.spacing(logoMaxHeight || 5) : "inherit"
        },
        _b["& .".concat(classes.logo)] = __assign({ width: "inherit !important", maxWidth: "100%", display: "inline-block", maxHeight: theme.spacing(logoMaxHeight || 5) }, (logoMarginTop && {
            marginTop: logoMarginTop
        })),
        _b["& .".concat(classes.title)] = {
            fontSize: "1.1rem",
            marginLeft: theme.spacing(1)
        },
        _b["& .".concat(classes.kLanguageSwitcherContainer)] = {
            gridArea: "language",
            marginLeft: "auto"
        },
        _b["& .".concat(classes.kLanguageSwitcher)] = {
            "& .MuiInputBase-formControl": {
                fontWeight: "bold",
                "&:before": {
                    display: "none"
                },
                "&:after": {
                    display: "none"
                }
            }
        },
        _b);
});

export { StyledKLandingHeader, classes };
//# sourceMappingURL=styles.js.map
